import React, { Component } from "react";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import LoadingIndicatorComponent from "../utils/loadingIndicator";
import axios from 'axios';

class AppointmentCancellationComponent extends Component {

    state = {
        appointment : null,
        dataRequestSent: false,
        dataLoaded: false
    };

    componentDidMount() {
        this.getAppointmentDetails();
    }

    getAppointmentDetails = () => {
        if(!this.state.dataRequestSent){
            this.state.dataRequestSent = true;

            axios.post('/api/get_booking_details/', {"id":this.props.appointmentId})
            .then(response => {
                if(response.status===200){
                    this.setState({ appointment: response.data.details, dataLoaded: true });
                }else{
                    toast.error("Termin koji pokušavate da otkažete ne postoji.");
                    this.setState({dataLoaded: true });
                }
                
            })
            .catch(function (error) {
                toast.error("Greška prilikom pronalaska termina.");
            });
        }
    }

    getPageContent = () => {
        if(this.state.dataLoaded){
            if(this.state.appointment){
                // podaci uspesno ucitani, prikazi UI za brisanje elementa
                return <div>
                    <h2>Otkazivanje zakazanog termina</h2>
                    <br/><br/>
                    <div className="panel panel-default">
                        <div className="panel-heading">
                            <h3 className="panel-title">Podaci o terminu koji otkazujete</h3>
                        </div>
                        <div className="panel-body">
                            <h4><b>Termin:</b> {this.state.appointment.termin}</h4>
                            <h4><b>Usluga:</b> {this.state.appointment.usluga}</h4><br/><br/>
                            <h6><b>Klikom na dugme ispod potvrđujete da ste saglasni sa otkazivanjem termina</b></h6><br/>
                            <div>
                                <button className="btn btn-primary" type="button" onClick={()=> this.props.onAppointmentCancellationRequest(this.state.appointment.id)}><i className="fa fa-trash" aria-hidden="true"></i>&nbsp;Potvrdi</button>
                            </div>
                        </div>
                    </div>
                </div>
            } else {
                // podaci nisu ucitani kako treba
                return <div>
                <h2>Otkazivanje zakazanog termina</h2>
                    <br/><br/>
                <p>Termin koji pokušavate da otkažete ne postoji.</p>
                </div>
            }
        }
    }


    render() { 
        if (!this.state.dataLoaded) {
            return <LoadingIndicatorComponent/>
        }

        return (  
            <section className="section-xl bg-periglacial-blue one-screen-page-content text-center">
                <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                />
                <div className="shell">
                    {this.getPageContent()}
                </div>
                </section>
      );
    }
}
 
export default AppointmentCancellationComponent;